import CommonThemeSelection from '../../../../components/common/CommonThemeSelection';
import ThemePreviewCard from '../../venue/venue-settings/components/ThemePreviewCard';

type Props = {
    isDefaultTheme: boolean;
    setIsDefaultTheme: React.Dispatch<React.SetStateAction<boolean>>;
    customColors: any;
    setCustomColors: React.Dispatch<React.SetStateAction<any>>;
};

export default function OrgThemeSelection({ isDefaultTheme, setIsDefaultTheme, customColors, setCustomColors }: Readonly<Props>) {
    const defaultColors = {
        primary: '#fbaa07',
        secondary: '#263238',
    };

    return (
        <CommonThemeSelection
            isDefaultTheme={isDefaultTheme}
            setIsDefaultTheme={setIsDefaultTheme}
            customColors={customColors}
            setCustomColors={setCustomColors}
            defaultColors={defaultColors}
            ThemePreviewComponent={ThemePreviewCard}
        />
    );
}
